const pad = (value) => String(value).padStart(2, "0");

const toDateKey = (value) => {
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null;
    return `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}`;
  }

  const match = String(value ?? "").match(/^(\d{4}-\d{2}-\d{2})/);
  return match?.[1] || null;
};

export function getWorkingPeriods(slots) {
  const periods = new Map();

  (Array.isArray(slots) ? slots : []).forEach((slot) => {
    const startDate = toDateKey(slot?.periodStart);
    const endDate = toDateKey(slot?.periodEnd);
    const dayOfWeek = Number(slot?.dayOfWeek);

    if (
      slot?.isAvailable === false ||
      !startDate ||
      !endDate ||
      !Number.isInteger(dayOfWeek) ||
      dayOfWeek < 0 ||
      dayOfWeek > 6
    ) {
      return;
    }

    const key = `${startDate}|${endDate}`;
    if (!periods.has(key)) {
      periods.set(key, { startDate, endDate, workingDays: new Set() });
    }
    periods.get(key).workingDays.add(dayOfWeek);
  });

  return Array.from(periods.values()).map((period) => ({
    ...period,
    workingDays: [...period.workingDays],
  }));
}

export function isNonWorkingDate(date, periods) {
  const dateKey = toDateKey(date);
  if (!dateKey || !(date instanceof Date)) return false;

  const period = (periods || []).find(
    (item) => dateKey >= item.startDate && dateKey <= item.endDate
  );

  return Boolean(period && !period.workingDays.includes(date.getDay()));
}